/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_home_featured_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Curated resources available on the Library`
};

const fr_home_featured_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Les collections de ressources phares de la Bibliothèque`
};

const de_home_featured_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Kuratierte Ressourcen in der Bibliothek verfügbar`
};

const es_home_featured_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Recursos seleccionados disponibles en la Biblioteca`
};

const it_home_featured_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Risorse selezionate disponibili nella Biblioteca`
};

const ar_home_featured_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `الموارد المنسقة المتاحة في المكتبة`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const home_featured_description23 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_featured_description23(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_featured_description23", locale)
	if (locale === "en") return en_home_featured_description23(inputs)
	if (locale === "fr") return fr_home_featured_description23(inputs)
	if (locale === "de") return de_home_featured_description23(inputs)
	if (locale === "es") return es_home_featured_description23(inputs)
	if (locale === "it") return it_home_featured_description23(inputs)
	return ar_home_featured_description23(inputs)
};
export { home_featured_description23 as "HOME_FEATURED_DESCRIPTION" }